window.abTesting.rerenderMainProductSection = function () {
	fetch(window.location.pathname + '?view=abtesting-variation')
		.then((res) => res.text())
		.then((html) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const variantPicker = doc.querySelector('[variant-picker-wrapper]');
			const productForm = document.querySelector('[variant-picker-wrapper]');
			productForm.innerHTML = variantPicker.innerHTML;
			const quickAdd = doc.querySelector('product-quick-add');
			const quickAddContainer = document.querySelector('product-quick-add');
			quickAddContainer.parentElement.replaceChild(quickAdd, quickAddContainer);
			productForm.classList.remove('product-section-variant-picker--B');
			productForm.classList.add('product-section-variant-picker--A', 'section--narrow');
		});
};
class ThumbnailsSlider extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.leftButton = this.querySelector('.thumbnails-button--left');
		this.rightButton = this.querySelector('.thumbnails-button--right');
		this.thumbnailWrapper = this.querySelector('.thumbnails-slider__content-wrapper');
		this.thumbnailSlider = this.querySelector('.product-gallery__thumbnail-list');
		this.initButtons();
		this.initCssVariables();
		this.initThumbnailMutationObserver();
		window.addEventListener('resize', this.initCssVariables.bind(this));
	}

	initCssVariables() {
		const thumbnailWrapperWidth = this.thumbnailWrapper.offsetWidth;
		const itemWidth = this.querySelector('.product-gallery__thumbnail').offsetWidth;
		const gapWidthDesktop = (thumbnailWrapperWidth - 6 * itemWidth) / 5;
		const gapWidthMobile = (thumbnailWrapperWidth - 5 * itemWidth) / 4;
		if (gapWidthDesktop > 0) {
			this.thumbnailWrapper.style.setProperty('--thumbnail-gap-desktop', `${gapWidthDesktop}px`);
		}
		if (gapWidthMobile > 0) {
			this.thumbnailWrapper.style.setProperty('--thumbnail-gap-mobile', `${gapWidthMobile}px`);
		}
	}

	initButtons() {
		this.leftButton.addEventListener('click', this.scrollToLeft.bind(this));
		this.rightButton.addEventListener('click', this.scrollToRight.bind(this));
		if (this.thumbnailSlider.offsetWidth <= this.thumbnailWrapper.offsetWidth) {
			this.hideButton(this.leftButton);
			this.hideButton(this.rightButton);
		}
	}

	initThumbnailMutationObserver() {
		const mutationCallback = (mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'aria-current') {
					const targetElement = mutation.target;
					if (targetElement.getAttribute('aria-current') === 'true') {
						const thumbnailWrapperRect = this.thumbnailWrapper.getBoundingClientRect();
						const targetElementRect = targetElement.getBoundingClientRect();

						if (targetElementRect.right > thumbnailWrapperRect.right) {
							this.scrollToRight();
						} else if (targetElementRect.left < thumbnailWrapperRect.left) {
							this.scrollToLeft();
						}
					}
				}
			}
		};

		const observer = new MutationObserver(mutationCallback);

		const observerConfig = {
			attributes: true,
			attributeFilter: ['aria-current'],
		};

		const observeItems = this.querySelectorAll('.product-gallery__thumbnail');

		for (const item of observeItems) {
			observer.observe(item, observerConfig);
		}
	}

	hideButton(button) {
		button.setAttribute('disabled', '');
	}

	scrollToLeft() {
		if (!this.leftButton.hasAttribute('disabled')) {
			this.thumbnailWrapper.scrollLeft = 0;
			this.leftButton.setAttribute('disabled', '');
			this.rightButton.removeAttribute('disabled');
		}
	}

	scrollToRight() {
		if (!this.rightButton.hasAttribute('disabled')) {
			this.thumbnailWrapper.scrollLeft = this.thumbnailSlider.offsetWidth - this.thumbnailWrapper.offsetWidth + 1;
			this.leftButton.removeAttribute('disabled');
			this.rightButton.setAttribute('disabled', '');
		}
	}
}
if (!customElements.get('thumbnails-slider')) {
	customElements.define('thumbnails-slider', ThumbnailsSlider);
}

class AutoCloseTabs extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.tabs = this.querySelectorAll('details');
		this.initMutationObserver();
		this.addTabsAttributes('autoclose');
	}

	addTabsAttributes(attribute) {
		this.tabs.forEach((tab) => {
			tab.setAttribute(attribute, '');
		});
	}

	initMutationObserver() {
		const mutationCallback = (mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
					const targetElement = mutation.target;
					if (targetElement.open) {
						this.updateTabs(targetElement);
						setTimeout(() => {
							this.scrollIntoView(targetElement);
						}, 200);
					}
				}
			}
		};
		const observer = new MutationObserver(mutationCallback);
		const observerConfig = {
			attributes: true,
			attributeFilter: ['open'],
		};
		for (const item of this.tabs) {
			observer.observe(item, observerConfig);
		}
	}

	updateTabs(targetElement) {
		this.tabs.forEach((tab) => {
			if (tab !== targetElement) {
				tab._open = false;
				tab._transition(false);
				tab.removeAttribute('open');
			}
		});
	}

	scrollIntoView(element) {
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}
}

if (!customElements.get('auto-close-tabs')) {
	customElements.define('auto-close-tabs', AutoCloseTabs);
}

// Function to append all parameters to clickout links
(function () {
	'use strict';

	// Get ALL parameters from current URL
	const urlSearchParams = new URLSearchParams(window.location.search);

	// Convert all parameters to string
	let paramsToAppend = urlSearchParams.toString();

	// If no parameters exist, use default
	if (!paramsToAppend) {
		paramsToAppend = 'onfySource=PharmaSGP';
		console.log('No parameters found. Using default:', paramsToAppend);
	} else {
		console.log('Passing all parameters from URL:', paramsToAppend);
	}

	// Helper function to append parameters to a URL
	function appendParamsToUrl(url) {
		if (!url || !paramsToAppend) return url;

		// Parse URL and its existing parameters
		const [baseUrl, queryString] = url.split('?');
		const existingParams = new URLSearchParams(queryString || '');
		const newParams = new URLSearchParams(paramsToAppend);

		// Add only parameters that don't already exist
		let hasNewParams = false;
		newParams.forEach((value, key) => {
			if (!existingParams.has(key)) {
				existingParams.append(key, value);
				hasNewParams = true;
			}
		});

		// Return original URL if no new parameters added
		if (!hasNewParams) return url;

		// Return URL with parameters
		return existingParams.toString() ? `${baseUrl}?${existingParams.toString()}` : baseUrl;
	}

	// Intercept window.open to add parameters to clickout links
	const originalWindowOpen = window.open;
	window.open = function (url, target, ...args) {
		// Only modify URLs going to onfy.de
		if (url && url.includes('onfy.de')) {
			const updatedUrl = appendParamsToUrl(url);
			if (updatedUrl !== url) {
				console.log('Added parameters to:', updatedUrl);
			}
			return originalWindowOpen.call(this, updatedUrl, target, ...args);
		}
		return originalWindowOpen.call(this, url, target, ...args);
	};
})();

// Run the script only if the page is a Shopify blog post
document.addEventListener('DOMContentLoaded', () => {
	if (window.location.pathname.includes('/blogs/')) {
		appendParamsToLinks();
	}
});

class RichAccordion extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.button = this.querySelector('.accordion__toggle--button');
		this.text = this.querySelector('.accordion__content');
		this.open = this.hasAttribute('open');
		this.setContentHeight();
		this.setInitialHeight();
		this.initButton(this.button);
		this.setMinHeight();
		window.addEventListener('resize', this.onWidthChange.bind(this));
	}

	setContentHeight() {
		this.maxHeight = this.text.scrollHeight;
	}

	setMinHeight() {
		if (this.hasAttribute('data-min-height-mobile')) {
			const minHeightMobile = this.convertRemToPixels(this.getAttribute('data-min-height-mobile'));
			this.text.style.setProperty('--accordion-toggle-min-height-mobile', `${minHeightMobile}px`);
		}
		if (this.hasAttribute('data-min-height-desktop')) {
			const minHeightDesktop = this.convertRemToPixels(this.getAttribute('data-min-height-desktop'));
			this.text.style.setProperty('--accordion-toggle-min-height-desktop', `${minHeightDesktop}px`);
		}
	}

	convertRemToPixels(rem) {
		return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}

	initButton(button) {
		button.addEventListener('click', this.toggleAccordion.bind(this));
	}

	setInitialHeight() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
		} else {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
		}
	}

	onWidthChange() {
		this.setContentHeight();
		this.setInitialHeight();
	}

	toggleAccordion() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
			this.open = false;
			this.setAttribute('aria-expanded', 'false');
		} else {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
			this.open = true;
			this.setAttribute('aria-expanded', 'true');
		}
	}
}

if (!customElements.get('rich-accordion')) {
	customElements.define('rich-accordion', RichAccordion);
}

class ScrollingCollapsible extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		if (!this.getAttribute('enabled') === 'true') {
			return;
		}
		this.button = this.querySelector('.scrolling-collapsible__button');
		this.text = this.querySelector('.prose');
		this.open = this.getAttribute('aria-expanded') === 'true';
		this.setContentHeight();
		this.setInitialHeight();
		this.initButton(this.button);
		this.setMinHeight();
		window.addEventListener('resize', this.onWidthChange.bind(this));
	}

	setContentHeight() {
		this.maxHeight = this.text.scrollHeight;
	}

	setMinHeight() {
		if (this.hasAttribute('data-min-height-mobile')) {
			const minHeightMobile = this.convertRemToPixels(this.getAttribute('data-min-height-mobile'));
			this.text.style.setProperty('--accordion-toggle-min-height-mobile', `${minHeightMobile}px`);
		}
		if (this.hasAttribute('data-min-height-desktop')) {
			const minHeightDesktop = this.convertRemToPixels(this.getAttribute('data-min-height-desktop'));
			this.text.style.setProperty('--accordion-toggle-min-height-desktop', `${minHeightDesktop}px`);
		}
	}

	convertRemToPixels(rem) {
		return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}

	initButton(button) {
		button.addEventListener('click', this.toggleAccordion.bind(this));
	}

	setInitialHeight() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
		} else {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
		}
	}

	onWidthChange() {
		this.setContentHeight();
		this.setInitialHeight();
	}

	toggleAccordion() {
		if (this.open) {
			this.text.style.setProperty('--accordion-toggle-height', '0px');
			this.open = false;
			this.setAttribute('aria-expanded', 'false');
		} else {
			this.text.style.setProperty('--accordion-toggle-height', `${this.maxHeight}px`);
			this.open = true;
			this.setAttribute('aria-expanded', 'true');
		}
	}
}

if (!customElements.get('scrolling-collapsible')) {
	customElements.define('scrolling-collapsible', ScrollingCollapsible);
}

// //-------------- Rating Snippet ------------------

const targetNode = document.querySelector('.product-mobile-title.product-mobile-title--B .product-info__app');

if (targetNode) {
	const config = { childList: true, subtree: true };

	const callback = (mutationsList, observer) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList') {
				const targetElement = document.querySelector(
					'.product-mobile-title.product-mobile-title--B .product-info__app .ruk_rating_snippet',
				);
				if (targetElement) {
					observer.disconnect();
					const title = targetElement.getAttribute('title');
					const rating = title.split(' ')[0];

					const count = targetElement.querySelector('.ruk-rating-snippet-count');
					if (count) {
						const countDiv = document.createElement('span');
						countDiv.classList.add('rating-snippet-count--B');
						countDiv.innerText = ` ${rating} `;
						count.prepend(countDiv);
						console.log(count);
					}
				}
			}
		}
	};

	const observer = new MutationObserver(callback);
	observer.observe(targetNode, config);
}

const CART_EXPERIMENT_ID = 53678672;
window.activateCartExperiment = () => {
	let experimentsTable = window.ablyft.get('activeExperimentIds');
	const isExperimentActive = !!experimentsTable[CART_EXPERIMENT_ID];
	window['ablyft'] = window['ablyft'] || [];
	if (!isExperimentActive) {
		window['ablyft'].push({
			eventType: 'activatePage',
			pageApiName: 'restaxil-cart-drawer-first-time-accessed',
		});
	}
};
document.addEventListener('variant:add', () => {
	window.activateCartExperiment();
});

//////////////////////////////////////////////////////
// Kameleoon Cross-Domain Tracking with Pandectes GDPR
(function () {
	'use strict';

	// Configuration
	const CONFIG = {
		debugMode: false, // Set to true for debugging
		kameleoonParamName: 'kam_visitor',
	};

	// Logging helper
	function log(message, data) {
		if (CONFIG.debugMode) {
			console.log(`[Kameleoon GDPR] ${message}`, data || '');
		}
	}

	// Initialize Kameleoon queue if not exists
	window.kameleoonQueue = window.kameleoonQueue || [];

	// Track last applied state to prevent duplicate API calls
	let lastAppliedState = undefined;

	// Step 1: Read and set visitor code from URL (BEFORE consent check)
	function setVisitorCodeFromURL() {
		const urlParams = new URLSearchParams(window.location.search);
		const visitorCodeFromURL = urlParams.get(CONFIG.kameleoonParamName);

		if (visitorCodeFromURL) {
			log('Found visitor code in URL', visitorCodeFromURL);

			// Set visitor code immediately using command queue
			window.kameleoonQueue.push({
				level: 'IMMEDIATE',
				command: function () {
					try {
						Kameleoon.API.Visitor.setVisitorCode(visitorCodeFromURL);
						log('Visitor code set successfully', visitorCodeFromURL);

						// Clean URL after setting the code
						cleanURLParameter();
					} catch (error) {
						log('Error setting visitor code', error);
					}
				},
			});
		} else {
			log('No visitor code found in URL');
		}
	}

	// Clean URL parameter after use
	function cleanURLParameter() {
		const url = new URL(window.location);
		url.searchParams.delete(CONFIG.kameleoonParamName);

		if (url.searchParams.toString() === '') {
			window.history.replaceState({}, document.title, url.pathname);
		} else {
			window.history.replaceState({}, document.title, url.toString());
		}
	}

	// Check current Pandectes consent from cookie
	// Returns: number (preferences), or null if no cookie/no decision
	function checkCurrentConsent() {
		try {
			// Look for pandectes_gdpr cookie
			const cookieMatch = document.cookie.match(/pandectes_gdpr=([^;]+)/);

			if (!cookieMatch || !cookieMatch[1]) {
				log('No Pandectes cookie found - consent not given yet');
				return null; // No cookie = no decision made yet
			}

			// Decode base64 and parse JSON
			const decodedValue = atob(cookieMatch[1]);
			const consentData = JSON.parse(decodedValue);

			log('Current Pandectes consent data', consentData);

			// Check if this is a real user decision or just default state
			// Pandectes sets consentType to help identify this
			if (consentData.consentType === 'default' || consentData.status === 'default') {
				log('Pandectes in default state - no user decision yet');
				return null;
			}

			// Check preferences value
			if (typeof consentData.preferences === 'number') {
				return consentData.preferences;
			} else if (consentData.status === 'allow') {
				// If status is allow but no preferences, user accepted all
				return 0;
			} else if (consentData.status === 'deny') {
				// User denied all
				return 7;
			} else {
				// Unknown state - treat as no decision
				log('Unknown Pandectes state - treating as no decision');
				return null;
			}
		} catch (error) {
			log('Error parsing Pandectes cookie', error);
			return null; // Error = no valid decision
		}
	}

	// Apply consent to Kameleoon based on Pandectes preferences
	function applyKameleoonConsent(preferences, source) {
		// Skip if state hasn't changed
		if (lastAppliedState === preferences) {
			log(`No change needed (${source}):`, preferences);
			return;
		}

		// Determine consent state text for logging
		const stateText =
			preferences === null
				? 'UNKNOWN (no decision)'
				: preferences === 0
				? 'ALL ALLOWED'
				: preferences === 7
				? 'ALL DENIED'
				: `PARTIAL (preferences: ${preferences})`;

		console.log(`[Kameleoon] Consent state: ${stateText} (source: ${source})`);

		// Only apply consent if we have a definitive decision (not null)
		if (preferences !== null) {
			window.kameleoonQueue.push({
				level: 'NORMAL',
				command: function () {
					try {
						// Check if Performance (2) or Targeting (4) cookies are allowed
						// preferences === 0 means all cookies allowed
						// (preferences & 2) === 0 means Performance allowed
						// (preferences & 4) === 0 means Targeting allowed

						const performanceAllowed = (preferences & 2) === 0;
						const targetingAllowed = (preferences & 4) === 0;
						const hasConsent = preferences === 0 || performanceAllowed || targetingAllowed;

						log('Pandectes preferences', {
							preferences: preferences,
							performanceAllowed: performanceAllowed,
							targetingAllowed: targetingAllowed,
							hasConsent: hasConsent,
						});

						if (hasConsent) {
							Kameleoon.API.Core.enableLegalConsent('BOTH');
							log('Kameleoon tracking ENABLED');
						} else {
							Kameleoon.API.Core.disableLegalConsent('BOTH');
							log('Kameleoon tracking DISABLED');
						}

						lastAppliedState = preferences;
					} catch (error) {
						log('Error applying Kameleoon consent', error);
					}
				},
			});
		} else {
			// Null state - Kameleoon will handle this automatically
			// Don't call enable or disable, let Kameleoon stay in null state
			lastAppliedState = null;
			log('Null state - Kameleoon remains in unknown state (no tracking)');
		}
	}

	// Listen for Pandectes consent events
	function listenForConsentChanges() {
		// Primary Pandectes event listener
		window.addEventListener('PandectesEvent_OnConsent', function (event) {
			log('Pandectes consent event received', event.detail);

			if (event.detail) {
				// Check if this is a real user decision
				if (event.detail.consentType === 'default') {
					log('Default consent event - ignoring (no user decision)');
					return;
				}

				if (typeof event.detail.preferences === 'number') {
					applyKameleoonConsent(event.detail.preferences, 'PandectesEvent_OnConsent');
					log('Consent type', event.detail.consentType);
				}
			}
		});

		// Also listen for consent updated events
		window.addEventListener('PandectesEvent_ConsentUpdated', function (event) {
			log('Pandectes consent updated event', event.detail);
			const currentPreferences = checkCurrentConsent();
			applyKameleoonConsent(currentPreferences, 'PandectesEvent_ConsentUpdated');
		});

		// No polling - only event-driven updates
		log('Event listeners registered');
	}

	// Initialize everything
	function initialize() {
		console.log('[Kameleoon GDPR] Initializing Pandectes integration');

		// Step 1: Set visitor code from URL immediately
		setVisitorCodeFromURL();

		// Step 2: Check current consent and apply
		// IMPORTANT: This might be null if user hasn't decided
		const currentPreferences = checkCurrentConsent();

		// Only apply if there's an actual decision
		if (currentPreferences !== null) {
			applyKameleoonConsent(currentPreferences, 'initialization');
		} else {
			console.log('[Kameleoon GDPR] No user consent decision yet - Kameleoon remains in null state');
			lastAppliedState = null;
		}

		// Step 3: Listen for consent changes (event-driven, no polling)
		listenForConsentChanges();

		// Debug info
		if (CONFIG.debugMode) {
			console.log('[Kameleoon GDPR] Debug info:', {
				currentPreferences: currentPreferences,
				cookieExists: document.cookie.includes('pandectes_gdpr'),
				kameleoonDefined: typeof Kameleoon !== 'undefined',
			});
		}
	}

	// Start initialization
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initialize);
	} else {
		initialize();
	}
})();

//////////////////////////////////////////////////////
// Reviews Anchor - Scroll to reviews section on rating snippet click
(function () {
	'use strict';

	function scrollToReviews() {
		const target = document.getElementById('reviews-io-carousel') || document.querySelector('reviewsio-product-reviews-widget');

		if (target) {
			const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 80;
			window.scrollTo({ top: targetPosition, behavior: 'smooth' });
		}
	}

	function init() {
		document.querySelectorAll('.ruk_rating_snippet').forEach(function (snippet) {
			snippet.addEventListener('click', scrollToReviews);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Watch for dynamically added snippets
	new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			mutation.addedNodes.forEach(function (node) {
				if (node.nodeType === 1 && node.classList && node.classList.contains('ruk_rating_snippet')) {
					node.addEventListener('click', scrollToReviews);
				}
			});
		});
	}).observe(document.body, { childList: true, subtree: true });
})();
